import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const PenIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 20)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 6.4 6.65 17.8 1 19l1.2-5.7L13.51 1.9a3.23 3.23 0 0 1 4.47 0v0a3 3 0 0 1 0 4.5v0Z" />
      <path
        transform="scale(.99688 1.00311) rotate(45 .67 16.23)"
        d="M0-.75h5.8"
      />
    </SVG>
  );
};

<svg
  width="20"
  height="20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
></svg>;
